// Stripe element overrides - see https://stripe.com/docs/stripe-js/reference

const stripeElementStyle = {
  base: {
    '::placeholder': {
      color: '#737c97', // gray600
      opacity: 1,
    },
  },
  invalid: {
    // gray800
    border: '1px solid #dc0d49',
    color: '#131e40', // red400
  },
};

export default stripeElementStyle;
